import request from '@/config/request.js'
import setting from '@/config/settings'
import { Message } from 'element-ui'
import Modules from '@/components/modules'
import RouteView from '@/components/routeView'
const ApiLogin = request.UserLogin
export default {
  name: 'login',
  data () {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.resetlogin.confirmPassword !== '') {
          this.$refs.resetPass.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请重复输入新密码'))
      } else if (value !== this.resetlogin.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      qiniu: setting.gbs.qiniu,
      login: {
        mobile: this.$store.state.login.logininfo.loginName,
        password: this.$store.state.login.logininfo.loginPwd,
        validCodeKey: '',
        validCodeValue: '',
        rememberMe: false
      },
      resetlogin: {
        mobile: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      },
      loginRules: {
        mobile: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        validCodeValue: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      checked: true,
      loading: false,
      codeChange: '',
      changeTeacher: false,
      changeTeacherList: [],
      appUrl: setting.gbs.host,
      changeItem: '',
      teacherID: '',
      codeUrl: '',
      loginType: 'pass',
      number: localStorage.getItem('bell-min') ? localStorage.getItem('bell-min') : -1,
      resetnumber: localStorage.getItem('bell-reset-min') ? localStorage.getItem('bell-reset-min') : -1,
      resetPassDialog: false,
      passRules: {
        mobile: [
          { required: true, message: '请输入新账号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 重置密码
    onResetPassWord (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          ApiLogin.resetPassword.call(this, { mobile: this.resetlogin.mobile, password: this.resetlogin.newPassword, authCode: this.resetlogin.code }, item => {
            this.resetnumber = -1
            this.resetPassDialog = false
            Message({
              message: item.result,
              type: 'success'
            })
          })
        }
      })
    },
    onChangeLoginType (type) {
      this.loginType = type
      this.$refs.loginruleForm.validate((valid) => {
      })
    },
    loginIn (loginruleForm) {
      const that = this
      this.$refs[loginruleForm].validate((valid) => {
        if (valid) {
          if (this.loginType === 'pass') {
            ApiLogin.login.call(this, { mobile: that.login.mobile, password: that.login.password }, res => {
              this.$store.dispatch('loginIn', 'Bearer ' + res.token)
              ApiLogin.listZoneTeacher.call(this, {}, teacher => {
                if (teacher.length > 1) {
                  that.changeTeacherList = teacher
                  that.changeTeacher = true
                } else {
                  this.$store.dispatch('setZoneId', teacher[0].schoolZone.zoneId)
                  ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
                    this.$store.dispatch('setOtoStatus', item)
                  })
                  // ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: teacher[0].teacherId }, item => {
                  //   this.$store.dispatch('setUserInfo', JSON.stringify(item))
                  //   this.$store.dispatch('setZoneId', teacher[0].schoolZone.zoneId)
                  //   ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
                  //     this.$store.dispatch('setOtoStatus', item)
                  //   })
                  // })
                  this.getTeacherLogin(teacher)
                }
              })
            })
          } else {
            ApiLogin.loginWithCode.call(this, { mobile: that.login.mobile, authCode: that.login.validCodeValue }, res => {
              this.$store.dispatch('loginIn', 'Bearer ' + res.token)
              ApiLogin.listZoneTeacher.call(this, {}, teacher => {
                if (teacher.length > 1) {
                  that.changeTeacherList = teacher
                  that.changeTeacher = true
                } else {
                  this.$store.dispatch('setZoneId', teacher[0].schoolZone.zoneId)
                  ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
                    this.$store.dispatch('setOtoStatus', item)
                  })
                  this.getTeacherLogin(teacher)
                }
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    routeMatch (array) {
      return new Promise((resolve) => {
        // return resolve([])
        let arr = []
        arr = array.map(item => {
          const listSplit = item.component.split('.')
          let module = ''
          if (item.component.indexOf('RouteView') > -1) {
            for (let i = 1; i < listSplit.length; i++) {
              module = module ? module[listSplit[i]] : RouteView[listSplit[i]]
            }
          } else if (item.component.indexOf('Modules') > -1) {
            for (let i = 1; i < listSplit.length; i++) {
              module = module ? module[listSplit[i]] : Modules[listSplit[i]]
            }
          }
          let listArr = []
          listArr = item.children.map(list => {
            let module = ''
            const splita = list.component.split('.')
            if (list.component.indexOf('RouteView') > -1) {
              for (let i = 1; i < splita.length; i++) {
                module = module ? module[splita[i]] : RouteView[splita[i]]
              }
            } else if (list.component.indexOf('Modules') > -1) {
              for (let i = 1; i < splita.length; i++) {
                module = module ? module[splita[i]] : Modules[splita[i]]
              }
            }
            return {
              path: this.getSrtSubstring(list.path),
              name: this.getSrtSubstring(list.path),
              meta: {
                name: list.name
              },
              component: module
            }
          })
          if (listArr.length > 0) {
            listArr = [{
              path: '/',
              redirect: to => {
                const str = listArr[0].path
                if (str.indexOf('/') > -1) {
                  return str.substr(1)
                } else {
                  return str
                }
              },
              hidden: true
            }, ...listArr]
          }
          return {
            path: item.path,
            meta: {
              name: item.name,
              keepAlive: true
            },
            component: module,
            children: listArr,
            name: item.path
          }
        })
        resolve(arr)
      })
    },
    getTeacherLogin (teacher = []) {
      ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: teacher[0].teacherId }, item => {
        this.$store.dispatch('setUserInfo', JSON.stringify(item))
        ApiLogin.getMenus.call(this, {}, dataMenu => {
          if (dataMenu.length === 0) {
            Message({
              message: '未分配任何菜单权限，请联系管理员！',
              type: 'error'
            })
          }
          this.setMenu(dataMenu).then(() => {
            this.routeMatch(JSON.parse(this.$store.state.login.rootMenu)).then(rt => {
              this.$router.options.routes = this.$router.options.routes.concat(rt)
              this.$router.addRoutes(rt)
              for (const router in dataMenu) {
                if (dataMenu[router].children.length > 0) {
                  this.$nextTick(() => {
                    const menuPath = dataMenu[router].children[0].path
                    const path = menuPath
                    this.$router.push({
                      path: dataMenu[router].path + path
                    })
                  })
                  break
                } else {
                  this.$nextTick(() => {
                    this.$router.push({
                      path: dataMenu[router].path
                    })
                  })
                }
              }
            })
          })
        })
      })
    },
    setMenu (menu) {
      return new Promise((resolve) => {
        this.$store.dispatch('setRootMenu', JSON.stringify(menu))
        resolve()
      })
    },
    getSrtSubstring (path) {
      if (path.indexOf('/') > -1) {
        return path.substr(1)
      } else {
        return path
      }
    },
    getTeacher () {
      ApiLogin.changeLoginZoneTeacher2.call(this, { zoneTeacherId: this.teacherID }, (res) => {
        this.$store.dispatch('loginIn', 'Bearer ' + res.token)
        this.$store.dispatch('setZoneId', res.zoneTeacher.schoolZone.zoneId)
        console.log(res)
        this.$nextTick(() => {
          ApiLogin.zoneFeatureIsBroadcast.call(this, {}, item => {
            this.$store.dispatch('setOtoStatus', item)
          })
          ApiLogin.getTeacherAccountInfoByTeacherId.call(this, { teacherId: this.teacherID }, item => {
            this.$store.dispatch('setUserInfo', JSON.stringify(item))
            ApiLogin.getMenus.call(this, {}, dataMenu => {
              if (dataMenu.length === 0) {
                Message({
                  message: '未分配任何菜单权限，请联系管理员！',
                  type: 'error'
                })
              }
              this.setMenu(dataMenu).then(() => {
                this.routeMatch(JSON.parse(this.$store.state.login.rootMenu)).then(rt => {
                  this.$router.options.routes = this.$router.options.routes.concat(rt)
                  this.$router.addRoutes(rt)
                  for (const router in dataMenu) {
                    if (dataMenu[router].children.length > 0) {
                      this.$nextTick(() => {
                        const menuPath = dataMenu[router].children[0].path
                        const path = menuPath
                        this.$router.push({
                          path: dataMenu[router].path + path
                        })
                      })
                      break
                    } else {
                      this.$nextTick(() => {
                        this.$router.push({
                          path: dataMenu[router].path
                        })
                      })
                    }
                  }
                })
              })
            })
          })
        })
      })
    },
    changeRadio (e) {
      this.teacherID = e
    },
    validCodeChange () {
      const randomKey = new Date().getTime() + Math.random()
      this.login.validCodeKey = randomKey
      this.$nextTick(() => {
        this.login.validCodeKey = randomKey
        this.codeUrl = this.appUrl + 'app/rest/school/green/security/validCodeKey?key=' + randomKey
      })
    },
    resetloginValidateCodeByManager (fn) {
      ApiLogin.loginValidateCodeByManager.call(this, { mobile: this.resetlogin.mobile }, item => {
        Message({
          message: item.result,
          type: 'success'
        })
        fn()
      })
    },
    loginValidateCodeByManager (fn) {
      ApiLogin.loginValidateCodeByManager.call(this, { mobile: this.login.mobile }, item => {
        Message({
          message: item.result,
          type: 'success'
        })
        fn()
      })
    },
    changeMine () {
      this.number = this.number - 1
      localStorage.setItem('bell-min', this.number)
    },
    resetChangeMine () {
      this.resetnumber = this.resetnumber - 1
      localStorage.setItem('bell-reset-min', this.resetnumber)
    },
    sendResetCodeChange () {
      const that = this
      if (that.resetnumber > -1) {
        return
      }
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (reg.test(that.resetlogin.mobile) === false) {
        Message({
          message: '请输入正确的手机号码',
          type: 'error'
        })
      } else {
        that.resetloginValidateCodeByManager(() => {
          that.resetnumber = 60
          const min = setInterval(function () {
            if (that.resetnumber > -1) {
              that.resetChangeMine()
            } else {
              clearInterval(min)
            }
          }, 1000)
        })
      }
    },
    sendCodeChange () {
      const that = this
      if (that.number > -1) {
        return
      }
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/
      if (reg.test(that.login.mobile) === false) {
        Message({
          message: '请输入正确的手机号码',
          type: 'error'
        })
      } else {
        that.loginValidateCodeByManager(() => {
          that.number = 60
          const min = setInterval(function () {
            if (that.number > -1) {
              that.changeMine()
            } else {
              clearInterval(min)
            }
          }, 1000)
        })
      }
    }
  },
  mounted () {
    const that = this
    const min = setInterval(function () {
      if (that.number > -1) {
        that.changeMine()
      } else {
        clearInterval(min)
      }
    }, 1000)
    const restMin = setInterval(function () {
      if (that.resetnumber > -1) {
        that.resetChangeMine()
      } else {
        clearInterval(restMin)
      }
    }, 1000)
  }
}
